<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-knowledge`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 3a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V3zm15.121 7.293l-1.414-1.414a1 1 0 00-1.414 0l-1.414 1.414a1 1 0 000 1.414l1.414 1.414a1 1 0 001.414 0l1.414-1.414a1 1 0 000-1.414zM38 23c0-7.732-6.268-14-14-14s-14 6.268-14 14c0 5.182 2.815 9.706 7 12.127V39a7 7 0 1014 0v-3.873c4.185-2.42 7-6.945 7-12.127zM24 37c1.03 0 2.033-.111 3-.322V39l-.005.176A3 3 0 0121 39v-2.322c.966.21 1.97.322 3 .322zm15.707-2.121l1.414 1.414a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0zm-30 0a1 1 0 00-1.414 0l-1.414 1.414a1 1 0 000 1.414l1.414 1.414a1 1 0 001.414 0l1.414-1.414a1 1 0 000-1.414l-1.414-1.414zM24 13c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm22 9a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2zM5 21a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1v-2a1 1 0 011-1h2zM9.707 8.879l1.414 1.414a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconKnowledge',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
